import InterestDisclosurePage from "./InterestDisclosurePage";
export default InterestDisclosurePage;
